import Footer from "../../footer"
import NavBar from "../../nav"

const CertificationService = () => {
  return <div className='certification'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Certification &amp; Support Services</h1>
				<div className="headline-divider sections"></div>
				<h2>Part 91. Part 121. Part 125. Part 135</h2>
			</div>
		</section>
    	<section className="clean-block clearfix">
			<div className="container content-container square-container">	
				<div className="grid-1 callout">		
					<div className="prose-header">Part 91 Operators</div>
					<div className="prose">
						<ul>
							<li>General Operations Manual</li>
							<li>RVSM Manuals (International Operations)</li>
							<li>MEL (LOA D195)</li>
							<li>International Procedures</li>
							<li>Safety Manual System</li>
						</ul>
					</div>
				</div>
				<div className="grid-2 callout">
					<div className="prose-header">Part 121 Operators</div>
					<div className="prose">
						<ul>
							<li>Certification Process Document</li>
							<li>8900.1 Volume 2 Chapter 3</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="container content-container square-container">
				<div className="grid-3 callout">
					<div className="prose-header">Part 125 and 135 Operations</div>
					<div className="prose">A Complete Manual System:
						<ul>
							<li>General Operations Manual</li>
							<li>General Maintenance Manual</li>
							<li>Minimum Equipment List</li>
							<li>International Procedures</li>
							<li>Flight Attendant Manual</li>
							<li>Safety Manual System</li>
							<li>Training Manuals</li>							
						</ul>
					</div>
				</div>
				<div className="grid-4 callout">
					<div className="prose-header">145 Repair Station</div>
					<div className="prose">
						<ul>
							<li>Repair Station Manual</li>
							<li>Quality Control Manual</li>
							<li>Training Manuals</li>
							<li>Forms</li>
							<li>Foreign Repair Station Differences</li>							
						</ul>
					</div>
				</div>
			</div>
			
		</section>
		<section className="clean-block clearfix">
			<div className="divider sections">Certification &amp; Compliance</div>			
			<div className="container content-container about-container">	
				<div className="prose">Fly Compliant, LLC with over twenty-five years of experience providing certification services has developed a standardized process to meet FAA requirements. By incorporating our Safety Management System (SMS) process our manuals are continuously being revised to meet best practices and standards. Our SMS approach will provide managers with the needed information to operate efficiently and within regulatory requirements.</div>	
				<div className="prose-header">Technical Publications</div>
				<div className="prose">Fly Compliant, LLC develops a compliant manual system per each operations specifications and unique operating requirements. Our technical manuals are written to the latest guidance using the latest tools for publishing quality manuals.</div>			
				<div className="prose-header">Support Services</div>
				<div className="prose">During certification process Fly Compliant, LLC will provide experienced guidance to meet standards. After certification ongoing support is provided, addressing and ever-changing regulatory environment.</div>	
			</div>	
		</section>
		<section className="clean-block clearfix">
			<div className="divider sections">Guidance Process</div>	
			<div className="container content-container square-container guidance-process-container">	
				<div className="grid-1 callout">		
					<div className="prose-header">Regulations</div>
					<div className="prose">Regulations are defined by the agency and are the rules to complied by operators under the respective part.</div>
				</div>
				<div className="grid-2 callout">
					<div className="prose-header">Notices</div>
					<div className="prose">Are recently published rulemaking documents to be included in the guidance. Note the date of the notice for currency.</div>
				</div>
				<div className="grid-3 callout">
					<div className="prose-header">Operations Specs.</div>
					<div className="prose">Operations Specifications are the limitations and authorizations specific to an operation.</div>
				</div>
				<div className="grid-4 callout">
					<div className="prose-header">Guidance</div>
					<div className="prose">The 8900.1 is guidance for FAA inspectors to adhered to standards and a method to comply with rules.</div>
				</div>
				<div className="grid-5 callout">
					<div className="prose-header">Advisory Circulars</div>
					<div className="prose">Advisory Circulars provide non-regulatory guidance to compliance with operating standards.</div>
				</div>
				<div className="grid-6 callout">
					<div className="prose-header">DRS</div>
					<div className="prose">The Dynamic Regulatory System is the FAA search engine for more than 65 document types maintained by the FAA.</div>
				</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default CertificationService